import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-asset-to-scene-help',
  templateUrl: './add-asset-to-scene-help.component.html',
  styleUrls: ['./add-asset-to-scene-help.component.scss'],
})
export class AddAssetToSceneHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
